<!-- Notifications Page -->
<section class="section-padding bg-light-theme">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <!-- Page Header -->
        <div class="page-header mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h2 class="text-light-black fw-700">
                <i class="fas fa-bell me-3"></i>
                Notifications
              </h2>
              <p class="text-light-white mb-0">
                Stay updated with your latest activities
              </p>
            </div>
            <div
              class="header-actions"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
              "
            >
              <button
                class="btn btn-outline-primary me-2"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 10px;
                "
                (click)="refreshNotifications()"
                [disabled]="isLoading"
                title="Refresh notifications"
              >
                <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
                <span class="d-none d-md-inline ms-2">Refresh</span>
              </button>
              <button
                *ngIf="getTabCount('unread') > 0"
                class="btn btn-primary"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 10px;
                "
                (click)="markAllAsRead()"
                [disabled]="isLoading"
              >
                <i class="fas fa-check-double me-2"></i>
                Mark All Read
              </button>
            </div>
          </div>
        </div>

        <!-- Notification Tabs -->
        <div class="notification-tabs mb-4">
          <ul class="nav nav-tabs justify-content-center">
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab === 'all'"
                href="javascript:void(0)"
                (click)="switchTab('all')"
              >
                All
                <span class="badge bg-secondary ms-2">{{
                  getTabCount("all")
                }}</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab === 'unread'"
                href="javascript:void(0)"
                (click)="switchTab('unread')"
              >
                Unread
                <span class="badge bg-primary ms-2">{{
                  getTabCount("unread")
                }}</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab === 'read'"
                href="javascript:void(0)"
                (click)="switchTab('read')"
              >
                Read
                <span class="badge bg-success ms-2">{{
                  getTabCount("read")
                }}</span>
              </a>
            </li>
          </ul>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="text-light-black mt-3">Loading notifications...</p>
        </div>

        <!-- Notifications List -->
        <div class="notifications-container" *ngIf="!isLoading">
          <!-- Empty State -->
          <div
            *ngIf="filteredNotifications.length === 0"
            class="empty-state text-center py-5"
          >
            <i
              class="fas fa-bell-slash text-muted mb-4"
              style="font-size: 4rem; opacity: 0.3"
            ></i>
            <h4 class="text-light-black">No notifications</h4>
            <p class="text-light-white mb-4">
              <span *ngIf="activeTab === 'all'"
                >You don't have any notifications yet.</span
              >
              <span *ngIf="activeTab === 'unread'"
                >All caught up! No unread notifications.</span
              >
              <span *ngIf="activeTab === 'read'"
                >No read notifications found.</span
              >
            </p>
            <button class="btn btn-primary" (click)="refreshNotifications()">
              <i class="fas fa-sync-alt me-2"></i>
              Refresh
            </button>
          </div>

          <!-- Notifications -->
          <div class="row" *ngIf="filteredNotifications.length > 0">
            <div
              *ngFor="
                let notification of filteredNotifications;
                trackBy: trackByNotificationId
              "
              class="col-12 mb-3"
            >
              <div
                class="notification-card"
                [class.unread]="!notification.read"
                [class.actionable]="isActionableReminder(notification)"
                (click)="onNotificationClick(notification)"
              >
                <div class="notification-content">
                  <div class="notification-icon">
                    <i
                      [class]="
                        getNotificationIcon(notification.type) +
                        ' ' +
                        getNotificationColor(notification.type)
                      "
                    ></i>
                  </div>
                  <div class="notification-body">
                    <div class="notification-header">
                      <h6 class="notification-title">
                        {{ getNotificationTitle(notification) }}
                      </h6>
                      <div class="notification-meta">
                        <span class="notification-time">{{
                          formatTime(notification.createdTime)
                        }}</span>
                        <span *ngIf="!notification.read" class="unread-badge">
                          <i class="fas fa-circle"></i>
                        </span>
                      </div>
                    </div>
                    <p class="notification-message">
                      {{ getNotificationMessage(notification) }}
                    </p>
                    <div class="notification-footer">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <small class="text-muted">{{
                          formatFullTime(notification.createdTime)
                        }}</small>

                        <!-- Action buttons for actionable reminders -->
                        <div
                          class="notification-actions"
                          *ngIf="isActionableReminder(notification)"
                        >
                          <button
                            class="btn btn-sm btn-success me-2"
                            (click)="confirmAppointment(notification, $event)"
                            title="Confirm Appointment"
                          >
                            <i class="fas fa-check me-1"></i>
                            Confirm
                          </button>
                          <button
                            class="btn btn-sm btn-outline-danger"
                            (click)="cancelAppointment(notification, $event)"
                            title="Cancel Appointment"
                          >
                            <i class="fas fa-times me-1"></i>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
